import { useQuery } from "@apollo/client";

import type {
  GetProductsByLocationQuery,
  GetProductsByLocationQueryVariables,
} from "../../../API";
import { GET_PRODUCTS_BY_LOCATION } from "../../../common/operations/queries";

export const useGetProductsByLocation = (locationId: string) => {
  const { data, loading } = useQuery<
    GetProductsByLocationQuery,
    GetProductsByLocationQueryVariables
  >(GET_PRODUCTS_BY_LOCATION, {
    variables: { locationId },
    skip: !locationId,
    fetchPolicy: "cache-and-network",
  });

  return { products: data?.getProductsByLocation ?? [], loading };
};
